/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


import { _DYN_SDK_EXTENSION } from "../__DynamicConstants";
var Version = '2.8.10';
var Internal = /** @class */ (function () {
    /**
     * Constructs a new instance of the internal telemetry data class.
     */
    function Internal(config) {
        this.sdkVersion = (config[_DYN_SDK_EXTENSION /* @min:%2esdkExtension */] && config[_DYN_SDK_EXTENSION /* @min:%2esdkExtension */]() ? config[_DYN_SDK_EXTENSION /* @min:%2esdkExtension */]() + "_" : "") + "javascript:" + Version;
    }
    return Internal;
}());
export { Internal };
//# sourceMappingURL=Internal.js.map